export default __webpack_public_path__ + "static/media/anesthesia.cc2d788b.svg";